import axios from "axios";

let groupCache = null;
let roleToPageCache = null;
let userDataCache = null;
let userRoleCache = null;

export const getRoleToPageAccess = async () => {
  if (roleToPageCache) return roleToPageCache;
  try {
    const response = await axios.get("/api/roleToPageAccess");
    roleToPageCache = response.data;
   
    return roleToPageCache;
  } catch (error) {
    console.error("Failed to fetch role to page access", error);
    throw error;
  }
};

export const getGroupToRoles = async () => {
  if (groupCache) return groupCache;
  try {
    const response = await axios.get("/api/groupids");
    groupCache = response.data;
    return groupCache;
  } catch (error) {
    console.error("Failed to fetch group to report", error);
    throw error;
  }
};

export const getUserData = async () => {
  if (userDataCache) return userDataCache;
  try {
    const response = await axios.get("/api/userData");
    userDataCache = response.data;
    return userDataCache;
  } catch (error) {
    console.error("Failed to fetch user data", error);
    throw error;
  }
};

export const getUserRole = async () => {
  if (userRoleCache) return userRoleCache;
  try {
    const response = await axios.get("/api/userToRole");
    userRoleCache = response.data;
    return userRoleCache;
  } catch (error) {
    console.error("Failed to fetch user role", error);
    throw error;
  }
};

export const uploadFileToBlob = async (file, onProgress, options = {}) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    if (options.subfolder) formData.append("subfolder", options.subfolder);
    if (options.containerName) formData.append("containerName", options.containerName);

    const response = await axios.post("/api/upload", formData, {
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          onProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
        }
      },
    });

    return response.data;
  } catch (error) {
    console.error("Failed to upload file to blob", error);
    throw error;
  }
};